import React, { useState } from "react";
import style from "./index.module.scss";
import { Tooltip } from "antd";
import { ActivityTaskDetail, ForCheckHomework } from "service/group";
import FileList from "../../../../../Group/Components/FileList";
import _ from "underscore";
import { useToggle } from "react-use";
import AsideLink from "../../../../../Group/Components/AddGroupActivityModal/Components/StepThree/Components/AsideLink";
import PreviewFileModal from "components/PreviewFileModal";
import classNames from "classnames";
import { TaskFileEntityListItem } from "../../../../../../../service/group";

const fileStyle = {
    backgroundColor: "transparent"
};

interface AnswerProps {
    task?: ActivityTaskDetail;
    homework?: ForCheckHomework;
}

export default function Answer({ task, homework }: AnswerProps) {
    //下载文件
    const handelDownload = (fileName: string, url: string) => {
        const newUrl = `${url}?attname=${encodeURIComponent(fileName)}`;
        window.open(newUrl);
    };

    const [list, setList] = useState<TaskFileEntityListItem[]>([]);

    //预览
    const [defaultIndex, setDefaultIndex] = useState(0);

    function onPrev(id?: number) {
        togglePrev();
        const index = _.findIndex(
            task?.taskFileEntityList || [],
            item => item.id === id
        );

        if (index !== undefined && index !== -1) {
            setDefaultIndex(index);
        }
    }

    //预览弹窗
    const [prevShow, togglePrev] = useToggle(false);

    return (
        <div>
            {/*任务详情开始*/}
            <div className={style.title}>
                <Tooltip title={task?.taskName || ""} placement="topLeft">
                    <span>{task?.taskName}</span>
                </Tooltip>
                <span className={style.score}>{task?.score}分</span>
            </div>
            <div className={style.topicWrapper}>
                <div
                    className={style.description}
                    dangerouslySetInnerHTML={{
                        __html:
                            task?.taskQuestion?.split("\n")?.join("<br/>") || ""
                    }}
                />
                <div
                    className={style.fileList}
                    onClick={() => setList(task?.taskFileEntityList || [])}>
                    {task?.taskFileEntityList &&
                        task?.taskFileEntityList.map(item => (
                            <FileList
                                key={item.key || item.id}
                                fileName={item.fileName}
                                fileSize={item?.fileSize}
                                isPreview
                                onPrev={() => onPrev(item.id)}
                                onDownload={() =>
                                    handelDownload(item.fileName, item.fileUrl)
                                }
                            />
                        ))}
                </div>
            </div>
            {/*任务详情结束*/}

            {/*学生作答内容开始*/}
            <div className={style.content}>
                <div className={style.tip}>小组回答</div>
                <div
                    className={style.answer}
                    dangerouslySetInnerHTML={{
                        __html:
                            homework?.taskAnswer?.split("\n")?.join("<br/>") ||
                            ""
                    }}
                />

                {homework?.homeworkFileList &&
                    homework.homeworkFileList.map(item => (
                        <div
                            key={item.id}
                            className={classNames(style.file)}
                            onClick={() =>
                                setList(homework?.homeworkFileList || [])
                            }>
                            <FileList
                                key={item.key || item.id}
                                fileName={item.fileName}
                                fileSize={item?.fileSize}
                                isPreview
                                onPrev={() => onPrev(item.id)}
                                onDownload={() =>
                                    handelDownload(item.fileName, item.fileUrl)
                                }
                                fileStyle={fileStyle}
                                maxNameWidth={300}
                            />
                        </div>
                    ))}
            </div>
            {/*学生作答内容结束*/}

            <PreviewFileModal
                visible={prevShow}
                onCancel={togglePrev}
                selectedIndex={defaultIndex}
                list={list || []}
                asideRender={list.map((item, index) => (
                    <AsideLink
                        key={item.id}
                        active={index === defaultIndex}
                        onClick={() => setDefaultIndex(index)}
                        item={item}
                    />
                ))}
            />
        </div>
    );
}
